import React from 'react';
import { Section, FadeIn } from './ui';
import { Star } from 'lucide-react';
export const TestimonialsSection = () => {
  const testimonials = [{
    quote: 'Leí las primeras páginas y me puse a llorar. No de tristeza — de alivio. Por fin alguien describía exactamente lo que yo sentía y no sabía cómo nombrar.',
    author: 'María G., 42 años, mamá de 3'
  }, {
    quote: 'Llevaba años sintiéndome sola en esto. Este libro me hizo sentir que no estoy loca, que no soy la única, y que sí hay salida. Lo recomiendo a toda mujer que conozco.',
    author: 'Carmen R., 51 años, trabajadora y mamá'
  }, {
    quote: "El capítulo del 'no' me cambió la vida. Nunca había podido decirlo sin sentirme terrible. Ahora lo digo y me siento libre.",
    author: 'Lucía M., 38 años, emprendedora'
  }];
  return <Section className="bg-navy-900 text-cream-100" data-id="element-250">
      <FadeIn data-id="element-251">
        <div className="text-center mb-16" data-id="element-252">
          <h2 className="text-3xl sm:text-4xl font-serif text-white mb-4" data-id="element-253">
            Esto es lo que dicen mujeres como tú
          </h2>
        </div>

        <div className="space-y-8" data-id="element-254">
          {testimonials.map((testimonial, i) => <FadeIn key={i} delay={i * 0.2} data-id="element-255">
              <div className="bg-navy-800 rounded-2xl p-8 sm:p-10 border border-navy-700 relative" data-id="element-256">
                <div className="flex gap-1 text-amber-400 mb-6" data-id="element-257">
                  {[...Array(5)].map((_, j) => <Star key={j} size={20} fill="currentColor" data-id="element-258" />)}
                </div>
                <p className="text-xl sm:text-2xl font-serif italic text-cream-100/90 leading-relaxed mb-6" data-id="element-259">
                  "{testimonial.quote}"
                </p>
                <p className="text-amber-400 font-medium" data-id="element-260">
                  — {testimonial.author}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </FadeIn>
    </Section>;
};